<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Withdrawal Beneficiaries</h4>
        <div class="text-muted small">Monitor and manage saved payout beneficiaries</div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadItems()">
        Refresh
      </button>
    </div>

    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-3">
            <label class="form-label">User ID</label>
            <input type="text" class="form-control" [(ngModel)]="filterUserId" [ngModelOptions]="{standalone: true}" />
          </div>

          <div class="col-md-3">
            <label class="form-label">Wallet ID</label>
            <input type="text" class="form-control" [(ngModel)]="filterWalletId" [ngModelOptions]="{standalone: true}" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Payment Method</label>
            <select class="form-select" [(ngModel)]="filterPaymentMethod" [ngModelOptions]="{standalone: true}">
              <option value="">All</option>
              <option *ngFor="let item of paymentMethodOptions" [value]="item">{{ item }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="filterIsActive" [ngModelOptions]="{standalone: true}">
              <option value="">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Search</label>
            <input type="text" class="form-control" [(ngModel)]="filterSearch" [ngModelOptions]="{standalone: true}" />
          </div>

          <div class="col-12">
            <button class="btn btn-primary" type="button" (click)="loadItems()">
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading beneficiaries...
        </div>

        <div class="table-responsive" *ngIf="!loading">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Created</th>
                <th>User ID</th>
                <th>Wallet ID</th>
                <th>Nickname</th>
                <th>Payment Method</th>
                <th>Destination Preview</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items">
                <td>{{ item.createdAt | date:'medium' }}</td>
                <td class="small">{{ item.userId }}</td>
                <td class="small">{{ item.walletId }}</td>
                <td>{{ item.nickname || '-' }}</td>
                <td>{{ item.paymentMethod || '-' }}</td>
                <td class="small">{{ previewDestination(item.destinationDetailsJson) }}</td>
                <td>
                  <span class="badge rounded-pill" [ngClass]="badgeClass(item.isActive)">
                    {{ item.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="text-end">
                  <button class="btn btn-outline-warning btn-sm" type="button" (click)="toggleStatus(item)">
                    {{ item.isActive ? 'Disable' : 'Enable' }}
                  </button>
                </td>
              </tr>

              <tr *ngIf="!items.length">
                <td colspan="8" class="text-center text-muted py-4">
                  No beneficiaries found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>